module.exports = __webpack_public_path__ + "static/yapisal-icerikler-bd99aed90ea4e3d8cc8bfcf06aa7659e.png";